<template>
  <v-dialog v-model="dialog.show" max-width="800">
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-timeline>
          <v-timeline-item
            v-for="(h, i) in historico"
            :key="i"
            :color="colorsStatus[h.status]"
            small
          >
            <template v-slot:opposite>
              <span
                :class="`font-weight-light ${colorsStatus[h.status]}--text`"
                v-text="$functions.formatDateFirebase(h.data.seconds)"
              ></span>
            </template>
            <div v-if="h.status !== undefined" class="py-4">
              <h2
                :class="`headline font-weight-light mb-4 ${colorsStatus[h.status]}--text`"
              >{{ h.status }}</h2>
              <div>{{ h.comentario }}</div>
            </div>
            <div v-else class="py-4">
              <h2 :class="`headline font-weight-light mb-4`">Lead Movimentada</h2>
            </div>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vendedor } from "@/services/lead";

export default {
  name: "DialogHistorico",

  data() {
    return {
      dialog: {
        show: false,
        title: "Historico"
      },
      serviceLeadsVendedor: new Vendedor(),
      historico: [],
      historicoContato: [],
      historicoMovimentacao: [],
      colorsStatus: {
        Andamento: "blue",
        Pendente: "orange",
        Sucesso: "green",
        Encerrado: "red"
      }
    };
  },

  methods: {
    async show(lead) {
      try {
        await this.getHistoricoContato(lead);
        await this.getHistoricoMovimentacao(lead);
        this.mesclaHistoricos();
        this.dialog.show = true;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    mesclaHistoricos() {
      this.historico = [];
      this.historico = this.historico.concat(
        this.historicoContato,
        this.historicoMovimentacao
      );
      for (let i = 0; i < this.historico.length; i++) {
        Object.keys(this.historico[i]).forEach(key => {
          if (key == "dataMovimentacao" || key == "dataContato") {
            this.historico[i]["data"] = this.historico[i][key];
          }
        });
      }
      this.historico = this.historico.sort((a, b) => a["data"] - b["data"]);
    },

    async getHistoricoContato(lead) {
      try {
        const response = await this.serviceLeadsVendedor.getHistoricoContato(
          lead
        );
        this.historicoContato = response;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getHistoricoMovimentacao(lead) {
      try {
        const response = await this.serviceLeadsVendedor.getHistoricoMovimentacao(
          lead
        );
        this.historicoMovimentacao = response;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    }
  }
};
</script>
